<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <v-col sm="2">
            <v-btn rounded  color="success" outlined @click="ExportToExcel" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
        </v-col> -->
    <!-- <v-btn  class="ma-2 no-display" tile outlined color="warning" @click="CartPdf()"> <v-icon left>mdi-printer</v-icon> Print</v-btn> -->
    <!-- excel btn code -->
    <v-row dense>
      <v-col cols="12" sm="6" md="6">
        <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'WeekTT')"
          :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
      </v-col>
    </v-row>
    <div id="tab">
      <div id="my-table-id">
        <v-simple-table v-for="(d, index) in ttlist" :key="index" class="elevation-1" dense>
          <caption style="text-align: left">
            <b>
              {{ d.day_name }}
            </b>
          </caption>

          <!-- <thead>
            <th></th>
            <th :colspan="div_list_size">{{ d.day_name }}</th>
          </thead> -->
          <thead>
            <th></th>
            <th v-for="(div, index2) in div_list" :key="index2">
              <center>{{ div }}</center>
            </th>
          </thead>
          <tbody>
            <tr v-for="(s, index1) in d.day_data" :key="index1">
              <td v-for="(slot, index3) in s" :key="index3">
                <v-btn x-small text>{{ slot.inst_name }}</v-btn>
                <span v-if="slot.elective_tt != ''">
                  <span v-for="(ett, index3) in slot.elective_tt" :key="index3">
                    <v-btn x-small text>{{ ett }}</v-btn>
                  </span>
                </span>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    days_list: [],
    slot_list: [],
    // extraBreadcrumbItems: [
   

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    div_list: [],
    div_list_size: null,
    ttlist: [],
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
  }),
  methods: {
    ExportToExcel() {
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/TimeTable/getWeakTTReport")
        .then((res) => {
          this.div_list = res.data.div_list;
          this.div_list_size = this.div_list.length;
          this.ttlist = res.data.ttlist;
          this.overlay = false;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    CartPdf() {
      var tab = document.getElementById("tab");
      // var tab1 = document.getElementById('tab1');
      var win = window.open("", "", "height=700,width=1000");
      win.document.write(tab.outerHTML);
      win.document.close();
      win.print();
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
thead {
  font-weight: bold !important;
}
th {
  font-weight: bold !important;
}
tr,
td,
th {
  border: 1px solid black;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid black;
  border: 1px solid black;
  font-size: small;
}
td {
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  img {
    width: 100% !important;
  }
  body,
  tr,
  th,
  td {
    font-size: small !important;
    font-weight: bold !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  table,
  td,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    font-weight: bold !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
</style>
